import { render } from "./NewUserCounts.vue?vue&type=template&id=416068dc&scoped=true"
import script from "./NewUserCounts.vue?vue&type=script&lang=js"
export * from "./NewUserCounts.vue?vue&type=script&lang=js"

import "./NewUserCounts.vue?vue&type=style&index=0&id=416068dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416068dc"]])

export default __exports__